import {
	ButtonComponent,
	ButtonColour,
	ButtonPriority,
	ButtonSize,
	ButtonType
} from '@vaa-component-lib/component.atom.button';
import {
	TypographyComponent,
	TypographySize,
	TypographyVariant,
	TypographyWeight
} from '@vaa-component-lib/component.atom.typography';
import { Counter, CounterInputs } from './counter.styles';
import {
	IconActionMinusComponent,
	IconActionPlusComponent
} from '@vaa-component-lib/component.atom.icons';
interface CounterComponentProps {
	id: string;
	minusDisabled?: boolean;
	plusDisabled?: boolean;
	minusOnChange: () => void;
	plusOnChange: () => void;
	minusLabel: string;
	plusLabel: string;
	value: number;
}

const CounterComponent = ({
	id,
	minusDisabled = false,
	plusDisabled = false,
	minusOnChange,
	plusOnChange,
	minusLabel,
	plusLabel,
	value
}: CounterComponentProps) => {
	return (
		<Counter id={`${id}-counter`}>
			<ButtonComponent
				priority={ButtonPriority.Primary}
				colour={ButtonColour.ContrastSecondary}
				disabled={minusDisabled}
				size={ButtonSize.XSmall}
				iconChild={<IconActionMinusComponent />}
				onClick={minusOnChange}
				aria-label={minusLabel}
				type={ButtonType.Button}
				data-testid={`${id}-minus-btn`}
			/>
			<CounterInputs>
				<TypographyComponent
					element="p"
					variant={TypographyVariant.Body}
					size={TypographySize.Mdm}
					weight={TypographyWeight.Medium}>
					{value}
				</TypographyComponent>
			</CounterInputs>
			<ButtonComponent
				priority={ButtonPriority.Primary}
				colour={ButtonColour.ContrastSecondary}
				disabled={plusDisabled}
				size={ButtonSize.XSmall}
				iconChild={<IconActionPlusComponent />}
				onClick={plusOnChange}
				aria-label={plusLabel}
				type={ButtonType.Button}
				data-testid={`${id}-plus-btn`}
			/>
		</Counter>
	);
};

export default CounterComponent;
